const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(-155 -167)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_149",
  "data-name": "Rectangle 149",
  width: 56,
  height: 56,
  rx: 10,
  transform: "translate(155 167)",
  fill: "#7836ff"
}), /*#__PURE__*/React.createElement("g", {
  id: "musicnote",
  transform: "translate(171 183)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "musicnote-2",
  "data-name": "musicnote",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "vuesax_bold_musicnote",
  "data-name": "vuesax/bold/musicnote"
}, /*#__PURE__*/React.createElement("g", {
  id: "musicnote-3",
  "data-name": "musicnote"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M18.5,5.056v1.17a2.755,2.755,0,0,1-1.08,2.31,2.507,2.507,0,0,1-1.51.47,3.131,3.131,0,0,1-1.03-.17L9.5,7.046v9.73A4.775,4.775,0,1,1,8,13.326V2.776A2.789,2.789,0,0,1,9.09.466a2.814,2.814,0,0,1,2.53-.3l4.42,1.48a3.83,3.83,0,0,1,2.46,3.41Z",
  transform: "translate(3.22 1.224)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector-2",
  "data-name": "Vector",
  d: "M0,0H24V24H0Z",
  fill: "none",
  opacity: 0
})))));
function SvgSongCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongCardIcon);
export default __webpack_public_path__ + "static/media/songCardIcon.be90de87901a44d16af5d4f92a490364.svg";
export { ForwardRef as ReactComponent };